import e,{Fragment as t}from"react";const a=({asset:{alt:a,presignedUrl:m}})=>e.createElement(t,null,m&&e.createElement("div",{className:"c-image-snippet"},e.createElement("img",{alt:a,className:"c-image-snippet__image",src:m})));export{a as ImageSnippet};
//# sourceMappingURL=ImageSnippet.js.map
